export const isAuthenticatedSelector = (state) => state.get('authentication').get('authenticated');

export const userInfoSelector = (state) => state.get('authentication').get('userInfo');

export const inAuthenticatedSectionSelector = (state) => state.get('authentication').get('inAuthenticatedSection') && state.get('ui').get('urlState').name !== 'kickstart';
